
export enum SyncResultStatus {
	Error = 'Error',
	NoAuth = 'NoAuth',
	NoConnection = 'NoConnection',
	Pending = 'Pending',
	Ok = 'Ok',
}

export enum SyncItemStatus {
	InvalidBody = 'Invalid Body',
	NoAuth = 'Not Authenticated',
	NoConnection = 'No Connection',
	NotModified = 'Not Modified',
	Ok = 'Ok',
	DownloadOk = 'DownloadOk',
	UploadOk = 'UploadOk',
	UpdateRequired = 'UpdateRequired',
	Canceled = 'Canceled',
	Pending = 'Pending',
	Unknown = 'Unknown',
}

export enum SyncItemStatusGroup {
	Success = 'Success',
	Pending = 'Pending',
	Error = 'Error',
}

// all of the item statuses should fall into
// one of the three categories...

export const syncItemStatusGroup = (status: SyncItemStatus): SyncItemStatusGroup => {
	switch(status) {
		case SyncItemStatus.NotModified:
		case SyncItemStatus.Ok:
		case SyncItemStatus.DownloadOk:
		case SyncItemStatus.UploadOk:
			return SyncItemStatusGroup.Success
		case SyncItemStatus.Pending:
			return SyncItemStatusGroup.Pending
		case SyncItemStatus.InvalidBody:
		case SyncItemStatus.NoAuth:
		case SyncItemStatus.NoConnection:
		case SyncItemStatus.UpdateRequired:
		case SyncItemStatus.Canceled:
		case SyncItemStatus.Unknown:
			return SyncItemStatusGroup.Error
	}
}

export const syncItemStatusIsSuccess = (status: SyncItemStatus): boolean => {
	return syncItemStatusGroup(status) === SyncItemStatusGroup.Success
}

export const syncItemStatusIsPending = (status: SyncItemStatus): boolean => {
	return syncItemStatusGroup(status) === SyncItemStatusGroup.Pending
}

export const syncItemStatusIsError = (status: SyncItemStatus): boolean => {
	return syncItemStatusGroup(status) === SyncItemStatusGroup.Error
}

export enum SyncDeviceToCloudOrdinalsStatus {
	Querying = 'querying'
}
